// Tenant-admin → seller impersonation helpers.
// State is persisted in localStorage so a hard refresh keeps the session
// active until the admin explicitly clicks "Exit" (or the backend session
// is closed elsewhere).

const KEY_USER = "kb_imp_seller_user_id";
const KEY_SHOP = "kb_imp_shop_name";
const KEY_SLUG = "kb_imp_shop_slug";
const KEY_SELLER = "kb_imp_seller_id";
const KEY_SESSION = "kb_imp_session_id";

export function getImpersonation() {
  try {
    const userId = localStorage.getItem(KEY_USER);
    if (!userId) return null;
    return {
      sellerUserId: userId,
      shopName: localStorage.getItem(KEY_SHOP) || "",
      shopSlug: localStorage.getItem(KEY_SLUG) || "",
      sellerId: localStorage.getItem(KEY_SELLER) || "",
      sessionId: localStorage.getItem(KEY_SESSION) || "",
    };
  } catch {
    return null;
  }
}

export function setImpersonation(payload) {
  try {
    localStorage.setItem(KEY_USER, payload.seller_user_id);
    localStorage.setItem(KEY_SHOP, payload.shop_name || "");
    localStorage.setItem(KEY_SLUG, payload.shop_slug || "");
    localStorage.setItem(KEY_SELLER, payload.seller_id || "");
    localStorage.setItem(KEY_SESSION, payload.session_id || "");
    window.dispatchEvent(new Event("kb-imp-changed"));
  } catch { /* ignore quota */ }
}

export function clearImpersonation() {
  try {
    [KEY_USER, KEY_SHOP, KEY_SLUG, KEY_SELLER, KEY_SESSION].forEach((k) =>
      localStorage.removeItem(k)
    );
    window.dispatchEvent(new Event("kb-imp-changed"));
  } catch { /* ignore */ }
}

export function getImpersonationHeader() {
  try {
    return localStorage.getItem(KEY_USER) || null;
  } catch {
    return null;
  }
}
